// Bewaart scroll-positie op /collections en /search pagina's wanneer
// een productlink wordt aangeklikt, en herstelt deze bij gebruik van de
// back-knop, ook nadat Dawn's facet-AJAX de grid opnieuw rendert.
(function () {
  function isListingPage() {
    return /^\/(collections|search)(\/|$|\?)/.test(location.pathname + location.search);
  }

  function key() {
    return 'sbd:scroll:' + location.pathname + location.search;
  }

  // Klik op een productlink in een collection/search context: scroll opslaan
  document.addEventListener(
    'click',
    function (e) {
      if (!isListingPage()) return;
      var link = e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!link) return;
      try {
        sessionStorage.setItem(key(), String(window.pageYOffset || window.scrollY || 0));
      } catch (_) {}
    },
    true
  );

  function tryRestore() {
    if (!isListingPage()) return;
    var stored;
    try {
      stored = sessionStorage.getItem(key());
    } catch (_) {
      return;
    }
    if (!stored) return;
    var target = parseInt(stored, 10);
    if (isNaN(target)) return;

    var attempts = 0;
    function step() {
      attempts++;
      // Wacht tot pagina-hoogte voldoende is om naar target te scrollen
      if (document.documentElement.scrollHeight >= target + window.innerHeight) {
        window.scrollTo({ top: target, behavior: 'instant' in window ? 'instant' : 'auto' });
        try { sessionStorage.removeItem(key()); } catch (_) {}
        return;
      }
      if (attempts < 25) setTimeout(step, 100); // tot ~2.5s wachten
    }
    step();
  }

  // bfcache hit
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) setTimeout(tryRestore, 0);
  });

  // Normale back: Dawn doet popstate -> herfetch -> DOM-replace; herstel daarna scroll
  window.addEventListener('popstate', function () {
    setTimeout(tryRestore, 100);
    setTimeout(tryRestore, 400);
    setTimeout(tryRestore, 1000);
  });

  // Eerste pageload (in geval browser teruggekeerd via niet-bfcache, geen popstate vuurde)
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(tryRestore, 50);
  } else {
    window.addEventListener('DOMContentLoaded', function () {
      setTimeout(tryRestore, 50);
    });
  }
})();
